<script>
import MixedGridPagePushItem from '@phoenix/mixins/components/mixedGrid/MixedGridPagePushItem';
import CTA from '@maison/components/common/CTA';
import PictureLazy from '@maison/components/common/PictureLazy';
import BackgroundVideo from '@maison/components/molecules/BackgroundVideo';

export default {
  components: {
    CTA,
    PictureLazy,
    BackgroundVideo,
  },

  mixins: [MixedGridPagePushItem],

  props: {
    image: {
      type: Object,
      default: null,
    },
    video: {
      type: Object,
      default: null,
    },
  },

  computed: {
    containerClasses() {
      return ['mixed-grid-card', { 'mixed-grid-card--large': this.size === 2 }].concat(this.displayClasses);
    },
    hasImage() {
      return this.image !== null;
    },
    hasVideo() {
      return this.video !== null && this.video.itemId && this.video.video;
    },
    videoId() {
      return this.hasVideo ? this.video.itemId : this.itemId;
    },
    videoPoster() {
      return this.hasVideo ? this.video.poster : '';
    },
    videoPosterOrFallback() {
      return this.videoPoster === '' && this.hasImage && this.image.src ? this.image.src : this.videoPoster;
    },
    videoSrc() {
      return this.hasVideo ? this.video.video : '';
    },
  },
};
</script>

<template>
  <div :class="containerClasses">
    <div class="mixed-grid-card__picture">
      <template v-if="hasVideo">
        <background-video
          :video-id="videoId"
          :video-src="videoSrc"
          :poster-src="videoPoster"
          :source-type="video.sourceType"
        />
      </template>
      <template v-else-if="hasImage">
        <div class="picture picture--cover">
          <picture-lazy v-bind="image" />
        </div>
      </template>
    </div>
    <div v-if="hasTitle || hasCta" class="mixed-grid-card__body">
      <div v-if="hasTitle" class="h5">{{ title }}</div>
      <c-t-a
        v-if="hasCta"
        v-bind="cta"
        :classes="['btn--link', 'btn--icon', 'expand-target']"
        icon="chevron-10"
        icon-bidirectional
      />
    </div>
  </div>
</template>
